import * as actionTypes from 'constants/ActionTypes';

export function getReqRates() {
    return {
        type: actionTypes.GET_REQ_LD_RATES.REQUEST,
    };
}

export function deleteReqRates() {
    return {
        type: actionTypes.DELETE_REQ_LD_RATES.REQUEST,
    };
} 

export function editReqRates() {
    return {
        type: actionTypes.EDIT_REQ_LD_RATES.REQUEST,
    };
} 




// WEBPACK FOOTER //
// ./app/actions/reqldRates/reqRates.js